import UploadFileBookIdField from './UploadFileBookIdField'
import withUploadFileBookIdField from './withUploadFileBookIdField'

const ConnectedUploadFileBookIdField = withUploadFileBookIdField(
  UploadFileBookIdField
)

export { ConnectedUploadFileBookIdField as UploadFileBookIdField }
